{
  "achievementCenter": "Achievement Center",
  "achievementCenterSubtitle": "Badges unlock करें, XP earn करें, level grow करें और अपनी Exalt Exchange identity बनाएं।",
  "badges": "Badges",
  "bearish": "Bearish",
  "bullish": "Bullish",
  "buy": "Buy",
  "comment": "टिप्पणी",
  "commentAddedSuccessfully": "टिप्पणी सफलतापूर्वक जोड़ी गई।",
  "commentFailed": "Comment failed",
  "communityFeed": "कम्युनिटी फीड",
  "communityPosts": "कम्युनिटी पोस्ट्स",
  "completedTrades": "Completed Trades",
  "copyCode": "कोड कॉपी करें",
  "copyLink": "लिंक कॉपी करें",
  "createSignalPost": "Signal / Market Post बनाएं",
  "currentLevel": "Current Level",
  "displayName": "Display Name",
  "disputes": "Disputes",
  "exaltTrader": "EXALT Trader",
  "failedCreatePost": "Post create नहीं हो सकी",
  "failedLoadAchievements": "उपलब्धियां लोड करने में विफल।",
  "failedLoadReputation": "प्रतिष्ठा लोड करने में विफल।",
  "failedLoadSocialTrading": "Social Trading load नहीं हो सकी",
  "failedRefreshAchievements": "उपलब्धियां रीफ़्रेश करने में विफल।",
  "failedRefreshReputation": "प्रतिष्ठा रीफ़्रेश करने में विफल।",
  "follow": "Follow",
  "followFailed": "Follow failed",
  "followers": "फ़ॉलोअर्स",
  "following": "फ़ॉलो कर रहे हैं",
  "fraudFlags": "Fraud Flags",
  "goldBadges": "गोल्ड बैज",
  "joinExaltUsingReferral": "मेरे रेफरल कोड का उपयोग करके Exalt Exchange से जुड़ें और ट्रेडिंग शुरू करें।",
  "joined": "शामिल हुए",
  "levelProgress": "Level Progress",
  "levelProgressText": "अगले स्तर तक पहुंचने के लिए XP अर्जित करते रहें।",
  "like": "Like",
  "likeFailed": "Like failed",
  "loading": "लोड हो रहा है...",
  "loadingAchievementCenter": "उपलब्धि केंद्र लोड हो रहा है...",
  "loadingQr": "QR कोड लोड हो रहा है...",
  "loadingReputationCenter": "प्रतिष्ठा केंद्र लोड हो रहा है...",
  "loadingSocialTrading": "Social Trading load हो रही है...",
  "locked": "Locked",
  "low": "कम",
  "myTraderProfile": "मेरा ट्रेडर प्रोफाइल",
  "neutral": "तटस्थ",
  "noAchievementProfileFound": "कोई उपलब्धि प्रोफ़ाइल नहीं मिली।",
  "noBadgesYet": "अभी कोई badges नहीं। Badges unlock करने के लिए activity बढ़ाएं।",
  "noPostsYet": "अभी कोई post नहीं।",
  "noReferralRewardsYet": "अभी तक कोई रेफरल इनाम नहीं।",
  "noReferredMembersYet": "आपने अभी तक किसी को रेफर नहीं किया है।",
  "noReputationHistoryYet": "अभी तक कोई प्रतिष्ठा इतिहास नहीं।",
  "noReputationProfileFound": "कोई प्रतिष्ठा प्रोफ़ाइल नहीं मिली।",
  "noTraders": "कोई ट्रेडर नहीं मिला।",
  "noTradersFound": "कोई trader नहीं मिला।",
  "p2pOrders": "P2P Orders",
  "p2pRating": "P2P Rating",
  "pair": "Pair",
  "platinum": "प्लैटिनम",
  "postCreatedSuccessfully": "पोस्ट सफलतापूर्वक बनाई गई।",
  "posting": "Post हो रही है...",
  "previous": "पिछला",
  "profitLoss": "लाभ / हानि",
  "publishPost": "Post Publish करें",
  "referralCodeCopied": "रेफरल कोड कॉपी हो गया।",
  "referralLinkCopied": "रेफरल लिंक कॉपी हो गया।",
  "referralLoadFailed": "रेफरल डेटा लोड करने में विफल।",
  "referralQrCode": "रेफरल QR कोड",
  "referralReward": "रेफरल इनाम",
  "referralRewardHistory": "रेफरल इनाम इतिहास",
  "referredUser": "रेफर किया गया उपयोगकर्ता",
  "refreshAchievements": "उपलब्धियां रीफ़्रेश करें",
  "refreshScore": "स्कोर रीफ़्रेश करें",
  "reputationCenter": "Community Reputation System",
  "reputationCenterSubtitle": "Trading trust, P2P success, verified badges और community activity के साथ अपनी Exalt identity बनाएं।",
  "reputationHistory": "प्रतिष्ठा इतिहास",
  "reputationScore": "Reputation Score",
  "searchYourMembers": "नाम या ईमेल से अपने सदस्यों को खोजें",
  "sell": "Sell",
  "send": "भेजें",
  "sentiment": "भावना",
  "serverError": "सर्वर त्रुटि।",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "shareMarketViewPlaceholder": "Market view, trading setup, EXALT update या signal share करें...",
  "shareReferralLink": "रेफरल लिंक साझा करें",
  "signal": "सिग्नल",
  "socialTradingSubtitle": "Expert traders को follow करें, market ideas share करें, signals देखें और EXALT trading community के साथ grow करें।",
  "socialTradingTitle": "सोशल ट्रेडिंग",
  "topTraders": "टॉप ट्रेडर्स",
  "topTradersLeaderboard": "Top Traders Leaderboard",
  "totalComments": "कुल कमेंट्स",
  "totalEarnings": "कुल कमाई",
  "totalLikes": "कुल लाइक्स",
  "totalReferrals": "कुल रेफरल",
  "totalTraders": "कुल ट्रेडर्स",
  "totalXp": "Total XP",
  "tradeType": "ट्रेड प्रकार",
  "tradingSuccess": "Trading Success",
  "unfollow": "अनफ़ॉलो करें",
  "unlocked": "Unlocked",
  "username": "उपयोगकर्ता नाम",
  "verified": "Verified",
  "winRate": "जीत दर",
  "writeBeforePosting": "Post करने से पहले कुछ लिखें।",
  "writeComment": "Comment लिखें...",
  "yourReferralCode": "आपका रेफरल कोड",
  "yourReferralLink": "आपका रेफरल लिंक",
  "yourReferredMembers": "आपके रेफर किए गए सदस्य"
}